// src/common/components/colorSchemeSelector/ColorSchemeSelector.tsx (веб-версия)

import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectColorScheme,
  setColorScheme,
  ColorSchemeType,
} from '../../../store/slices/settingsSlice'
import classes from './ColorSchemeSelector.module.sass'
import { ColorSchemes } from '../../utils/theme'

export const ColorSchemeSelector = () => {
  const dispatch = useDispatch()
  const colorScheme = useSelector(selectColorScheme)
  const schemes = Object.keys(ColorSchemes) as ColorSchemeType[]

  return (
    <div className={classes.container}>
      <div className={classes.grid}>
        {schemes.map((key) => (
          <div
            key={key}
            className={`${classes.colorOption} ${colorScheme === key ? classes.active : ''}`}
            onClick={() => dispatch(setColorScheme(key))}
          >
            <div
              className={classes.colorCircle}
              style={{ backgroundColor: ColorSchemes[key].primary }}
            />
            {colorScheme === key && (
              <div className={classes.checkContainer}>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
            )}
            <span className={classes.label}>{ColorSchemes[key].name}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
